import e from"./languageList.js";const r=(t,a=navigator.language)=>e[a]?e[a][t]:e["en-US"][t];export default r;
